<template>
  <div
    v-if="data"
    class="basic_wrap profile_wrap"
  >
    <div class="red_top_bg profile_header">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div
        class="big_tit"
        style="font-size: 14px;"
      >
        {{ data.name }}
      </div>
      <div class="top_right" />
    </div>
    <div class="feiziInfo">
      <div class="topInfo profile_summary">
        <div class="profile_name"><span>{{ data.name }}</span></div>
        <div class="profile_metrics">
          <span style="margin-right: 20px;">{{ $t('sky.height') }}: {{ formatMeasure(data.height, 'CM') }}</span>
          <span>{{ $t('sky.high') }}：{{ formatMeasure(data.xiong) }}</span>
        </div>
        <div class="profile_tags">
   <!--       <span
            v-if="data.keys[0]"
            class="van-tag  van-tag--primary"
          >{{ data.keys[0] }}</span>
          <span
            v-if="data.keys[1]"
            class="van-tag  van-tag--success"
          >{{ data.keys[1] }}</span>
          <span
            v-if="data.keys[2]"
            class="van-tag  van-tag--danger"
          >{{ data.keys[2] }}</span>
          <span
            v-if="data.keys[3]"
            class="van-tag  van-tag--warning"
          >{{ data.keys[3] }}</span> -->
        </div>
        <div class="profile_rating">
          <span>
            {{ $t('sky.fee') }}：
          </span>
          <div
            tabindex="0"
            role="radiogroup"
            class="van-rate van-rate--readonly"
          >
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="1"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="1"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="2"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="2"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="3"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="3"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="4"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="4"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
            <div
              role="radio"
              tabindex="0"
              aria-setsize="5"
              aria-posinset="5"
              aria-checked="true"
              class="van-rate__item"
            >
              <i
                data-score="5"
                class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                style="color: rgb(242, 178, 71); font-size: 15px;"
              />
            </div>
          </div>
        </div>
        <div class="profile_address">
          {{ $t('sky.addr') }}：{{ data.addr }}
        </div>
        <div
          class="yuyueBox profile_reserve"
          @click="yuyue()"
        >
          {{ $t('sky.yuenow') }}
        </div>
        <div
          class="dianzanimg profile_like"
          @click="dianzan()"
        >
          <div
            class="van-image"
            style="width: 60px; height: 60px;"
          >
            <img
              src="../images/home/zan.png"
              class="van-image__img"
              style="object-fit: cover;"
            >
          </div>
          <p style="color: #6b22b3; margin: 0px;font-size: 14px;">
            {{ data.zan }}
          </p>
        </div>
      </div>
      <div class="cenInfo profile_gallery">
        <!-- <div >
		            <div  class="van-tabs van-tabs--line">
		                <div class="van-tabs__wrap">
							<div class="head-tabs">
							    <span @click="cur=0;" class="tab-item " :class="cur==0?'active':''">
								{{$t('sky.pic')}}
								</span>
								<span @click="cur=1;" class="tab-item " :class="cur==1?'active':''">
								{{$t('sky.profile')}}
								</span>
							</div>
		                </div>
		                <div class="van-tabs__content"></div>
		            </div>
		        </div> -->
        <div v-if="cur==0">
          <!--     <div  class="imgswiper">
		                <div  style="width: 100px; height: 100px; margin-right: 10px;">
		                    <div  class="imgI van-image" style="width: 100px; height: 100px;">
								<img :src="data.pic" class="van-image__img" style="object-fit: cover;"></div>
		                </div>
		            </div> -->
          <div
            v-if="profileImages.length"
            class="profile_gallery_stage profile_gallery_collection"
          >
            <div
              v-for="(image, index) in profileImages"
              :key="index"
              class="profile_gallery_slide"
            >
              <img
                :src="'https://imgs.foreverclub.top'+image"
                class="profile_gallery_image"
              >
            </div>
          </div>
          <div
            v-else
            class="van-image profile_gallery_stage"
          >
            <img
              v-if="data.pic"
              :src="data.pic"
              class="van-image__img profile_gallery_image"
            >
          </div>
        </div>
        <div style="padding-top: 20px; display: none;" />
      </div>

      <div
        v-if="cur==1"
        class="btmInfo"
      >
        <!--    <div  style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold;">
				{{$t('sky.profile')}}
				</div> -->
        <div style="color: rgb(83, 69, 137);">
          {{ data.desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,List,Card,ShareSheet
	} from "vant";
    var _that;
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Vprofile",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				yizan:false,
				page:1,
				list:null,
				cur:0,
				imgs:null,
				area:null,
				arealist:null,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
			};
		},
		computed: {
			profileImages() {
				return Array.isArray(this.imgs) ? this.imgs.filter((image) => image) : [];
			}
		},
		created() {
			this.$parent.footer("girl",true);
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			formatMeasure(value, unit = '') {
				if (value === null || value === undefined || String(value).trim() === '') return '--';
				const measure = String(value).trim();
				return unit && !/[\'"]/.test(measure) ? `${measure}${unit}` : measure;
			},
			yuyue(){
				this.$toast(this.$t('sky.jihuo'));
			},
			dianzan(){
				if(this.yizan){
					this.data.zan = this.data.zan-1;
					this.yizan = false;
				}else{
					this.data.zan = this.data.zan+1;
					this.yizan = true;
				}
			},
			start() {
				Fetch('/index/girl', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data.girl;
					this.data.keys = this.data.keystr.split('|');
					this.imgs = this.data.imgs.split('|');
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	
.feiziInfo {
background: #ebedf0
}

.feiziInfo>div {
padding: 16px 20px;
background: #fff;
margin-bottom: 16px
}

.feiziInfo .topInfo {
position: relative
}

.feiziInfo .topInfo>div:first-child {
font-weight: 600
}

.feiziInfo .topInfo>div:first-child>span:first-child {
color: #2c1868;
font-size: 20px
}

.feiziInfo .topInfo>div:first-child>span:nth-child(2) {
color: #f2b247;
font-size: 20px
}

.feiziInfo .topInfo>div:nth-child(2) {
color: #6b22b3;
font-size: 12px;
margin: 10px 0
}

.feiziInfo .topInfo>div:nth-child(3) {
width: 50%
}

.feiziInfo .topInfo>div:nth-child(3)>div {
background: linear-gradient(50deg,#9b54ca,#e6557f);
color: #fff;
display: inline-block;
border-radius: 10px;
margin-right: 15px;
font-size: 12px;
padding: 8px;
margin-bottom: 15px
}

.feiziInfo .topInfo>div:nth-child(3)>div:nth-child(5) {
margin-right: 16vw
}

.feiziInfo .topInfo .yuyueBox {
position: absolute;
right: 16px;
bottom: 20px;
color: #fff;
padding: 10px 15px;
background: linear-gradient(20deg,#e73266,#ee5380);
border-radius: 7vw
}

.feiziInfo .topInfo .dianzanimg {
position: absolute;
top: 16px;
right: 7vw;
text-align: center
}

.feiziInfo .cenInfo .van-tab__text {
font-size: 18px
}

.feiziInfo .cenInfo .imgswiper {
width: 100%;
overflow-x: scroll;
margin: 16px 0;
display: flex;
flex-wrap: nowrap
}

.feiziInfo .cenInfo .imgswiper>div .imgI.active {
border: 5px solid #e54878
}
/deep/ .van-tag{
	margin: 5px 5px 5px 0;
}
.feiziInfo .topInfo > div[data-v-508625eb]:nth-child(2){
	line-height: 25px;
	margin: 5px 0;
}
.head-tabs{
	padding-left: 0px;
	padding-top: 5px;
	text-align: left;
}

/* Profile page visual system aligned with the home black-gold palette. */
.profile_wrap {
	min-height: 100vh;
	padding-bottom: 76px;
	background:
		radial-gradient(circle at 92% 7%, rgba(124, 4, 5, .34), transparent 25%),
		linear-gradient(180deg, #1b0c08 0, #120907 30%, #120907 100%);
	box-sizing: border-box;
}

.profile_wrap .profile_header {
	position: relative;
	height: 62px;
	background: linear-gradient(105deg, #120907, #32140d) !important;
	border-bottom: 1px solid rgba(185, 135, 59, .42);
	box-shadow: 0 5px 16px rgba(0, 0, 0, .26);
}

.profile_wrap .profile_header .big_tit {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 62px;
	padding: 0 66px;
	box-sizing: border-box;
	color: #e6b669;
	font-size: 16px !important;
	font-weight: 600;
	letter-spacing: .4px;
	text-shadow: 0 1px 8px rgba(230, 182, 105, .2);
}

.profile_wrap .profile_header .back_left {
	top: 19px;
	left: 15px;
	width: 24px;
	height: 24px;
	border: 1px solid rgba(230, 182, 105, .62);
	border-radius: 50%;
	background-color: rgba(47, 17, 10, .86);
	box-shadow: 0 3px 8px rgba(0, 0, 0, .25);
}

.profile_wrap .feiziInfo {
	padding: 12px 10px 0;
	background: transparent;
}

.profile_wrap .feiziInfo > div {
	margin-bottom: 12px;
	padding: 0;
	background: transparent;
}

.profile_wrap .profile_summary {
	min-height: 222px;
	padding: 15px 15px 16px !important;
	border: 1px solid rgba(185, 135, 59, .5);
	border-radius: 14px;
	background:
		radial-gradient(circle at 94% 6%, rgba(148, 48, 24, .24), transparent 28%),
		#1b100d !important;
	box-shadow: 0 12px 22px rgba(0, 0, 0, .25);
	box-sizing: border-box;
}

.profile_wrap .profile_name {
	max-width: calc(100% - 76px);
	margin-bottom: 8px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.profile_wrap .profile_name > span {
	color: #f4d188 !important;
	font-size: 21px !important;
	font-weight: 600;
	letter-spacing: .3px;
}

.profile_wrap .profile_metrics,
.profile_wrap .profile_address,
.profile_wrap .profile_rating {
	display: flex;
	align-items: center;
	min-height: 30px;
	margin: 0;
	color: #f5dfbd;
	font-size: 13px;
	line-height: 30px;
}

.profile_wrap .profile_metrics {
	color: #d9bd99 !important;
}

.profile_wrap .profile_metrics span:first-child {
	margin-right: 22px !important;
}

.profile_wrap .profile_tags {
	display: none;
}

.profile_wrap .profile_rating > span,
.profile_wrap .profile_address {
	color: #c9ab86 !important;
	font-size: 13px !important;
}

.profile_wrap .profile_rating .van-rate {
	margin-left: 3px;
}

.profile_wrap .profile_rating .van-rate__icon {
	color: #e6b669 !important;
	text-shadow: 0 0 7px rgba(230, 182, 105, .22);
}

.profile_wrap .profile_reserve {
	position: static !important;
	display: block;
	margin: 10px 0 0 !important;
	padding: 10px 12px !important;
	border: 1px solid rgba(230, 182, 105, .75);
	border-radius: 9px !important;
	background: linear-gradient(90deg, #690b0b, #9d321a) !important;
	box-shadow: inset 0 1px 0 rgba(255, 230, 170, .14), 0 5px 10px rgba(0, 0, 0, .2);
	color: #ffe4a5 !important;
	font-size: 15px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}

.profile_wrap .profile_like {
	position: absolute !important;
	top: 15px !important;
	right: 13px !important;
	margin: 0;
	color: #e6b669;
}

.profile_wrap .profile_like .van-image {
	width: 44px !important;
	height: 44px !important;
	padding: 8px;
	border: 1px solid rgba(230, 182, 105, .6);
	border-radius: 50%;
	background: rgba(90, 15, 10, .72);
	box-sizing: border-box;
}

.profile_wrap .profile_like .van-image__img {
	// filter: sepia(1) saturate(1.7) hue-rotate(340deg) brightness(1.35);
}

.profile_wrap .profile_like p {
	margin: 2px 0 0 !important;
	color: #e6b669 !important;
	font-size: 12px !important;
}

.profile_wrap .profile_gallery {
	padding: 0 !important;
	overflow: hidden;
	border: 1px solid rgba(185, 135, 59, .5);
	border-radius: 14px;
	background: #1b100d !important;
	box-shadow: 0 12px 22px rgba(0, 0, 0, .24);
}

.profile_wrap .profile_gallery_stage {
	display: block;
	width: 100% !important;
	height: 128vw !important;
	max-height: 520px;
	min-height: 385px;
	background: #120907;
}

.profile_wrap .profile_gallery_image {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover !important;
	filter: sepia(.24) saturate(.8) brightness(.82) contrast(1.08);
}

.profile_wrap .profile_gallery_slide {
	width: 100%;
	height: 128vw;
	min-height: 385px;
	max-height: 520px;
	overflow: hidden;
}

.profile_wrap .profile_gallery_collection {
	display: block;
	height: auto !important;
	min-height: 0;
	max-height: none;
}

.profile_wrap .profile_gallery_collection .profile_gallery_slide + .profile_gallery_slide {
	margin-top: 6px;
	border-top: 1px solid rgba(185, 135, 59, .35);
}

.profile_wrap .btmInfo {
	padding: 15px !important;
	border: 1px solid rgba(185, 135, 59, .45);
	border-radius: 13px;
	background: #1b100d !important;
	color: #f5dfbd;
	line-height: 28px;
}
// .feiziInfo > div{
// 	padding-top: 0px;
// }

/* Profile details follow the light Forever Link member palette. */
.profile_wrap { min-height: 100vh; padding-bottom: calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }.profile_wrap .profile_header { background: rgba(255, 252, 245, .98) !important; border-bottom-color: rgba(190, 139, 52, .45); box-shadow: 0 4px 14px rgba(125, 82, 35, .08); }.profile_wrap .profile_header .big_tit { color: #873126; text-shadow: none; }.profile_wrap .profile_header .back_left { border-color: rgba(190, 139, 52, .5); background-color: #fff7df; box-shadow: 0 3px 8px rgba(125, 82, 35, .1); }.profile_wrap .profile_summary, .profile_wrap .btmInfo, .profile_wrap .profile_gallery { border-color: rgba(190, 139, 52, .46) !important; background: #fffdf8 !important; box-shadow: 0 9px 20px rgba(125, 82, 35, .08); color: #533126 !important; }.profile_wrap .profile_name > span { color: #873126 !important; }.profile_wrap .profile_metrics, .profile_wrap .profile_rating > span, .profile_wrap .profile_address { color: #815c45 !important; }.profile_wrap .profile_gallery_stage { background: #fff7df; }.profile_wrap .profile_gallery_image { filter: none; }.profile_wrap .profile_reserve { border-color: rgba(166, 35, 61, .42); background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff8e8 !important; box-shadow: 0 7px 16px rgba(126, 28, 47, .18); }.profile_wrap .profile_like { color: #a6233d; }.profile_wrap .profile_like .van-image { border-color: rgba(166, 35, 61, .35); background: #fff5e8; }.profile_wrap .profile_like p, .profile_wrap .profile_rating .van-rate__icon { color: #b9802e !important; }

/* User-center teal surface: profile cards use the same calm account palette. */
.profile_wrap { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); color: #123d42; }
.profile_wrap .profile_header { height: 50px; border-bottom-color: #c7e0dd; background: rgba(255, 255, 255, .97) !important; box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }
.profile_wrap .profile_header .big_tit { display: flex; align-items: center; justify-content: center; height: 50px; }
.profile_wrap .profile_header .big_tit, .profile_wrap .profile_name > span { color: #073f47 !important; }
.profile_wrap .profile_header .back_left { top: 13px; display: flex; align-items: center; justify-content: center; box-sizing: border-box; border-color: #a8d5d0; background: #e8f5f3 !important; box-shadow: 0 3px 8px rgba(10, 73, 79, .08); }
.profile_wrap .profile_header .back_left::after { width: 8px; height: 8px; margin-left: 3px; border-bottom: 2px solid #073f47; border-left: 2px solid #073f47; content: ''; transform: rotate(45deg); }
.profile_wrap .profile_header .back_left:active { background-color: #d7eeeb !important; }
.profile_wrap .profile_summary, .profile_wrap .btmInfo, .profile_wrap .profile_gallery { border-color: #c9e1de !important; background: rgba(255, 255, 255, .95) !important; box-shadow: 0 9px 20px rgba(12, 75, 79, .08); color: #123d42 !important; }
.profile_wrap .profile_metrics, .profile_wrap .profile_rating > span, .profile_wrap .profile_address { color: #60797c !important; }
.profile_wrap .profile_gallery_stage { background: #e8f5f3; }
.profile_wrap .profile_reserve { border-color: #0c7b83; background: #073f47 !important; color: #fff !important; box-shadow: 0 7px 16px rgba(11, 70, 76, .16); }
.profile_wrap .profile_like { color: #08646d; }.profile_wrap .profile_like .van-image { border-color: #a8d5d0; background: #e8f5f3; }
.profile_wrap .profile_like p, .profile_wrap .profile_rating .van-rate__icon { color: #0d8d94 !important; }

/* Account-center spacing and card rhythm for the profile details. */
.profile_wrap .feiziInfo { padding: 16px 14px 0; }
.profile_wrap .feiziInfo > div { margin-bottom: 14px; }
.profile_wrap .profile_summary { min-height: 0; padding: 18px 16px 16px !important; border-radius: 16px; }
.profile_wrap .profile_metrics { flex-wrap: wrap; gap: 0 12px; line-height: 24px; }
.profile_wrap .profile_metrics span:first-child { margin-right: 0 !important; }
.profile_wrap .profile_rating, .profile_wrap .profile_address { min-height: 28px; line-height: 28px; }
.profile_wrap .profile_reserve { margin-top: 12px !important; border-radius: 12px !important; font-weight: 600; line-height: 25px; }
.profile_wrap .profile_gallery, .profile_wrap .btmInfo { border-radius: 16px; }
</style>
